import React from "react";
import {
  Box,
  Card,
  CardBody,
  HStack,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { formatNumber, formatPercent } from "../networkReportFormatters";
import ReportStatusBadge from "./ReportStatusBadge";
import {
  DevelopmentFactorList,
  FactorList,
  OrganizationActions,
} from "./OrganizationReportTable";

const DetailRow = ({ label, children }) => (
  <HStack justify="space-between" align="start" spacing={4}>
    <Text color="gray.500" fontSize="sm">{label}</Text>
    <Box textAlign="right" fontSize="sm">{children}</Box>
  </HStack>
);

const OrganizationReportCardList = ({ organizations = [], networkId }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const mutedColor = useColorModeValue("gray.600", "gray.400");

  return (
    <VStack align="stretch" spacing={3}>
      {organizations.map((organization) => {
        const hasMeasuredData = !["not_started", "no_survey"].includes(organization.status);

        return (
          <Card key={organization.id} bg={cardBg} borderWidth="1px" borderColor={borderColor}>
            <CardBody>
              <VStack align="stretch" spacing={3}>
                <Box>
                  <Text fontWeight="semibold">{organization.organizationName}</Text>
                  <Text fontSize="sm" color={mutedColor}>{organization.surveyName}</Text>
                </Box>
                <DetailRow label="Status">
                  <ReportStatusBadge status={organization.status} />
                </DetailRow>
                <DetailRow label="Completion">{formatPercent(organization.completionRate)}</DetailRow>
                <DetailRow label="Stability">
                  {hasMeasuredData ? formatNumber(organization.overallStabilityIndex) : "N/A"}
                </DetailRow>
                <DetailRow label="Strengths">
                  <FactorList factors={hasMeasuredData ? organization.strengths : []} />
                </DetailRow>
                <DetailRow label="Development areas">
                  <DevelopmentFactorList factors={hasMeasuredData ? organization.developmentAreas : []} />
                </DetailRow>
                <OrganizationActions organization={organization} networkId={networkId} size="sm" />
              </VStack>
            </CardBody>
          </Card>
        );
      })}
    </VStack>
  );
};

export default OrganizationReportCardList;
